import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { reloadOnceForChunk } from "@/components/ErrorBoundary";

window.addEventListener("error", (e) => reloadOnceForChunk(e.error));
window.addEventListener("unhandledrejection", (e) => reloadOnceForChunk(e.reason));
window.addEventListener("load", () => setTimeout(() => sessionStorage.removeItem("mm_chunk_reload"), 10000));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
